/**
 * Entity colors for consistent styling across Knowledge Base Index components
 */
export const ENTITY_COLORS = {
  knowledgeBase: "#6B7280", // gray
  note: "#10B981", // green
  document: "#3B82F6", // blue
  investment: "#F59E0B", // amber
  firm: "#8B5CF6", // purple
  company: "#EC4899", // pink
} as const;

export type EntityType = keyof typeof ENTITY_COLORS;
